/* eslint-disable react/no-unescaped-entities */
import PropTypes from 'prop-types';
import {
  HertzLogo,
  EntreprenistaLogo,
  NatureBoxLogo,
  BlommaLogo,
} from '../../../resources/logos';

export const PartnershipShape = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  logoSetPaths: PropTypes.string,
  body: PropTypes.string.isRequired,

  linkButtonText: PropTypes.string,
  linkUrl: PropTypes.string.isRequired,

  clickTrackingLabel: PropTypes.string.isRequired,
};

export const Partnerships = [
  {
    id: 2,
    value: 'perks.hertz.value',
    body: 'perks.hertz.body',
    logo: HertzLogo,
    linkUrl:
      'https://www.hertz.com/us/en/deals-and-offers/industrious-access-members',
    clickTrackingLabel: 'Hertz',
  },
  {
    id: 3,
    value: 'perks.entreprenista.value',
    body: 'perks.entreprenista.body',
    logo: EntreprenistaLogo,
    linkUrl:
      'https://calendly.com/d/cwzx-228-gcb/entreprenista-league-overview?a4=Industrious%20Marketplace',
    clickTrackingLabel: 'Entreprenista',
  },
  {
    id: 4,
    value: 'perks.nature_box.value',
    body: 'perks.nature_box.body',
    logo: NatureBoxLogo,
    linkUrl: 'https://naturebox.com/industrious',
    clickTrackingLabel: 'NatureBox',
  },
  {
    id: 5,
    value: 'perks.blomma.value',
    body: 'perks.blomma.body',
    logo: BlommaLogo,
    linkUrl: 'https://www.blomma.com/',
    clickTrackingLabel: 'Blomma',
  },
];
